/**
 * 立体透视图相关的reducer
 */
import { combineReducers } from 'redux'
import {
  SET_NETWORKNODES, SET_NETWORKNODETYPERELATION, SET_RELATIONS, SET_2DMODE, SET_ADDEDDRAGGEDNODEIN3D
} from '../actions/threeDPerspectiveDiagram_action'

function networkNodes(state = [], action) {
    switch (action.type) {
        case SET_NETWORKNODES:
            return action.networkNodes
        default:
            return state
    }
}

function networkNodeTypeRelation(state = [], action) {
    switch (action.type) {
        case SET_NETWORKNODETYPERELATION:
            return action.networkNodeTypeRelation
        default:
            return state
    }
}

function relations(state = [], action) {
    switch (action.type) {
        case SET_RELATIONS:
            return action.relations
        default:
            return state
    }
}

function b2DMode(state = false, action) {
    switch (action.type) {
        case SET_2DMODE:
            return action.b2DMode
        default:
            return state
    }
}

function bAddedDraggedNodeIn3D(state = false, action) {
    switch (action.type) {
        case SET_ADDEDDRAGGEDNODEIN3D:
            return action.bAddedDraggedNodeIn3D
        default:
            return state
    }
}

const threeDPerspectiveDiagramReducer = combineReducers({
    networkNodes,
    networkNodeTypeRelation,
    relations,
    b2DMode,
    bAddedDraggedNodeIn3D
})

export default threeDPerspectiveDiagramReducer
